import { render } from "./OrderEdit.vue?vue&type=template&id=64053250&scoped=true&ts=true"
import script from "./OrderEdit.vue?vue&type=script&lang=ts"
export * from "./OrderEdit.vue?vue&type=script&lang=ts"

import "./OrderEdit.vue?vue&type=style&index=0&id=64053250&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64053250"]])

export default __exports__